import React, { useContext, useEffect, useState } from "react";
import { contextpass } from "../App";
import EduExp from "../images/expedu-inner.png";
import Experience from "../components/Experience";
import Education from "../components/Education";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaGraduationCap, FaLaptopCode } from "react-icons/fa";
import { Helmet } from "react-helmet";



function ExpEdu() {
  const { pass } = useContext(contextpass);
  const [mode] = pass;
  const [show, setshow] = useState(false);
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end

  
  return (
    <section
      className={
        mode === true
          ? "align-items-center row bg-6"
          : "align-items-center row bg-3"
      }
    >
     <Helmet>
        <meta
          name="description"
          content="As a front-end developer, design and development are very important
to me. I think my technical expertise and sense of aesthetics make
me a well-rounded developer who can handle any challenge."
        />
        <title>Experience & Education - Muhammed Mubashir</title>
      </Helmet>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      >
        <div className="inner-sec">
          {show === true ? <Experience /> : <Education />}
          <motion.button
            className="btn sec-btn para-mar"
            initial={{ opacity: 0.6 }}
            whileHover={{
              scale: 1.1,
              transition: { duration: 1 },
            }}
            whileTap={{ scale: 0.9 }}
            whileInView={{ opacity: 1 }}
            onClick={() => setshow((n) => !n)}
          >
            {show === true ? (
              <span>
                Education
                <span className="ms-2">
                  <FaGraduationCap />
                </span>
              </span>
            ) : (
              <span>Experience<span className="ms-2"><FaLaptopCode/></span></span>
            )}
          </motion.button>
        </div>
      </motion.div>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12 text-center"
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}
      >
        <img src={EduExp} alt="EduExp" className="sec-img-w" />
      </motion.div>
    </section>
  );
}

export default ExpEdu;
